import { Default, Detail,  List, Create } from "./views";



const Module = {
    name: "costs",
    defaultRoutePath: "/cars/cost",
    menuItemScope: "fleet",
    menuItemName: "costs_and_interventions",

    routes: [
        {
            path: "/cars/cost",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],
    
}

export default Module;
